import { CALL_API, Schemas } from '../../common/middleware/api';

export const ZOOM_ACCESS_TOKEN_REQUEST = 'ZOOM_ACCESS_TOKEN_REQUEST';
export const ZOOM_ACCESS_TOKEN_SUCCESS = 'ZOOM_ACCESS_TOKEN_SUCCESS';
export const ZOOM_ACCESS_TOKEN_FAILURE = 'ZOOM_ACCESS_TOKEN_FAILURE';

export const ZOOM_REVOKE_ACCESS_TOKEN_REQUEST = 'ZOOM_REVOKE_ACCESS_TOKEN_REQUEST';
export const ZOOM_REVOKE_ACCESS_TOKEN_SUCCESS = 'ZOOM_REVOKE_ACCESS_TOKEN_SUCCESS';
export const ZOOM_REVOKE_ACCESS_TOKEN_FAILURE = 'ZOOM_REVOKE_ACCESS_TOKEN_FAILURE';

export const requestAccessToken = ({ code, centerId }, onSuccess, onError) => ({
	[CALL_API]: {
		types: [ZOOM_ACCESS_TOKEN_REQUEST, ZOOM_ACCESS_TOKEN_SUCCESS, ZOOM_ACCESS_TOKEN_FAILURE],
		endpoint: 'api/zoom/oauth/token',
		method: 'POST',
		request: { code, centerId },
		onSuccessEvent: onSuccess,
		onErrorEvent: onError
	}
});

export const revokeAccessToken = ({ centerId }, onSuccess, onError) => ({
	[CALL_API]: {
		types: [ZOOM_REVOKE_ACCESS_TOKEN_REQUEST, ZOOM_REVOKE_ACCESS_TOKEN_SUCCESS, ZOOM_REVOKE_ACCESS_TOKEN_FAILURE],
		endpoint: 'api/zoom/oauth/revoke',
		method: 'POST',
		request: { centerId },
		schema: Schemas.CENTER,	// request returns updated center details
		onSuccessEvent: onSuccess,
		onErrorEvent: onError
	}
});